import moment from "moment";
import HeaderCell from "components/table/HeaderCell";
import { Box, Image, Tag } from "@chakra-ui/react";

const getStatusColor = (status) => {
  switch (status) {
    case "Requested":
      return "#FFD6D6";
    case "Live":
      return "#E4FAEE";
    case "Pending Approval":
      return "#FF000029";
    case "Rejected":
      return "#FBF5E2";
    case "Sold":
      return "#E7E7E7";
    default:
      return "gray.100";
  }
};

const getStatusTextColor = (status) => {
  switch (status) {
    case "Requested":
      return "#FF0000";
    case "Live":
      return "#157E36";
    case "Pending Approval":
      return "#6C4800";
    case "Rejected":
      return "#6C4800";
    case "Sold":
      return "#505052";
    default:
      return "gray.100";
  }
};

const columns = (handleViewClick) => [
  {
    name: <HeaderCell label={"ID"} />,
    selector: (row) => row.id,
  },
  {
    name: <HeaderCell label={"DATE RAISED"} />,
    selector: (row) => moment(row.date_raised).format("DD/M/YYYY"),
  },
  {
    name: <HeaderCell label={"DESCRIPTION"} />,
    selector: (row) => row.description,
  },
  {
    name: <HeaderCell label={"STATUS"} />,
    selector: (row) => {
      return (
        <Tag
          bg={getStatusColor(row.status)}
          borderRadius="full"
          px="4"
          py="2"
          w={"auto"}
          justifyContent={"center"}
          alignItems={"center"}
          color={getStatusTextColor(row.status)}
          fontFamily={"PlusJakartaSansRegular"}
          fontSize={"16px"}
        >
          <Box
            bg={getStatusTextColor(row.status)}
            width={"8px"}
            height={"8px"}
            borderRadius={50}
            marginRight={"10px"}
          />
          {row?.status.charAt(0).toUpperCase() + row?.status.slice(1)}
        </Tag>
      );
    },
  },
  {
    name: <HeaderCell label={"ACTIONS"} />,
    selector: (row) => (
      <Image
        src={require("assets/svgs/eye.svg").default}
        onClick={() => handleViewClick(row)}
        _hover={{ cursor: "pointer" }}
      />
    ),
  },
];

export {
	columns
}